import type { Call } from "../model/call";
import { soundOwner, useSound, useVolumes, volumeKey } from "@shared/media";
import { AudioView } from "./TrackView";

/**
 * Звук звонка — то, что слышно, пока идёт разговор.
 *
 * Стоит отдельно от всякой панели и ничего не рисует. Раньше он висел на
 * полосе идущего звонка, и это работало ровно до тех пор, пока полосу не
 * начали прятать: у скрытой панели дорожки размонтировались бы вместе с ней,
 * и человек, открывший голосовой канал, переставал бы слышать собеседников.
 *
 * По той же причине его не кладут ни в плашку участника, ни в сетку звонка:
 * плашку можно прокрутить за край, а голос от этого пропадать не должен.
 */
export function CallAudio({ call }: { call: Call }) {
  const volumes = useVolumes();
  const sound = useSound();
  const heard = soundOwner(sound);

  if (call.state !== "live") return null;

  return (
    <>
      {call.audio.map((slot, index) => (
        <AudioView
          key={`${slot.publication.trackSid}-${index}`}
          publication={slot.publication}
          /*
           * Звук трансляции — только у той, что слушают: развёрнутой или
           * закреплённой. Не отписываемся, а глушим — переключение между
           * трансляциями должно быть мгновенным, а подписка заново стоит
           * секунды тишины.
           */
          volume={
            slot.screen && slot.owner !== heard
              ? 0
              : (volumes[volumeKey(slot.owner, slot.screen)] ?? 1)
          }
        />
      ))}
    </>
  );
}
